import React, { useState, useEffect } from "react";
import { Heading, Box } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import IssbContainer from "../IssbContainer";
import AIReviewSourcesPanel from "./AIReviewSourcesPanel";
import AIReviewQuestionsPanel from "./AIReviewQuestionsPanel";
import AIReviewRelaxPanel from "./AIReviewRelaxPanel";
import WizardStepWrapper from "../WizardStepWrapper";
import { postQuestionsAnswerJob } from "api/ai/ai.service";
import { useSelector } from "react-redux";
import { useQuery, useQueryClient } from "react-query";
import questionnaireService from "../../../api/issb/questionnaire.service";

const STEPS = ["SELECT_SOURCES", "SELECT_REQUIREMENTS", "RELAX"];

export default function AIReviewPage() {
  const navigate = useNavigate();
  const [stepIndex, setStepIndex] = useState(0);
  const [nextDisabled, setNextDisabled] = useState(false);
  const [sourceIds, setSourceIds] = useState([]);
  const [questionIds, setQuestionIds] = useState([]);
  const [questionFilter, setQuestionFilter] = useState("");
  const [sourceRoundIds, setSourceRoundIds] = useState([]);
  const [foundationQuestionIds, setFoundationQuestionIds] = useState([]);
  const [roundQuestionIds, setRoundQuestionIds] = useState([]);
  const [foundationEnabled, setFoundationEnabled] = useState(true);
  const [documentsEnabled, setDocumentsEnabled] = useState(false);
  const [otherRoundsEnabled, setOtherRoundsEnabled] = useState(false);
  const [task, setTask] = useState(null);
  const roundSelector = useSelector((state) => state.issbRound);
  const questionnaireId = roundSelector.selectedRound.id;

  const queryClient = useQueryClient();

  const { data: questionnaireData } = useQuery(questionnaireId, () => questionnaireService.get(questionnaireId), {
    enabled: !!questionnaireId,
  });
  // Wizard defaults to no rounds selected — user must explicitly choose
  useEffect(() => {
    setSourceRoundIds([]);
  }, [questionnaireData]);

  const gotoNext = () => {
    // kick off the review?
    if (stepIndex === 1) {
      const allQuestionIds = [
        ...(foundationEnabled && foundationQuestionIds.length > 0 ? foundationQuestionIds : []),
        ...(otherRoundsEnabled && roundQuestionIds.length > 0 ? roundQuestionIds : []),
      ];
      let fileinfoSpec = {
        other_fileinfo_ids: documentsEnabled ? sourceIds : [],
        round_ids: otherRoundsEnabled ? sourceRoundIds : [],
        question_ids: allQuestionIds.length > 0 ? allQuestionIds : undefined,
      };

      postQuestionsAnswerJob({
        questionnaireId,
        questionIds,
        filterLabel: questionFilter || undefined,
        overwrite: "AI",
        draft: true,
        fileinfoSpec,
      }).then((task) => {
        setTask(task);
        queryClient.invalidateQueries("taskService.list");
      });
    }
    setStepIndex(stepIndex + 1);
  };

  return (
    <IssbContainer>
      <Box mr="300px">
        <WizardStepWrapper
          nextText={stepIndex === 1 ? "Start Review" : "Next"}
          previousText="Previous"
          gotoNext={gotoNext}
          gotoPrevious={stepIndex === 2 ? false : () => setStepIndex(stepIndex - 1)}
          onCancel={() => navigate(-1)}
          stepIndex={stepIndex}
          steps={STEPS}
          superTitle="AI Review"
          nextDisabled={nextDisabled}
        >
          {/* TODO: local tweat, to remove back */}
          {stepIndex === 0 && (
            <AIReviewSourcesPanel
              setNextDisabled={setNextDisabled}
              sourceIds={sourceIds}
              setSourceIds={setSourceIds}
              sourceRoundIds={sourceRoundIds}
              setSourceRoundIds={setSourceRoundIds}
              foundationQuestionIds={foundationQuestionIds}
              setFoundationQuestionIds={setFoundationQuestionIds}
              foundationEnabled={foundationEnabled}
              setFoundationEnabled={setFoundationEnabled}
              documentsEnabled={documentsEnabled}
              setDocumentsEnabled={setDocumentsEnabled}
              otherRoundsEnabled={otherRoundsEnabled}
              setOtherRoundsEnabled={setOtherRoundsEnabled}
              roundQuestionIds={roundQuestionIds}
              setRoundQuestionIds={setRoundQuestionIds}
            />
          )}
          {stepIndex === 1 && (
            <AIReviewQuestionsPanel
              questionIds={questionIds}
              setQuestionIds={setQuestionIds}
              questionFilter={questionFilter}
              setQuestionFilter={setQuestionFilter}
            />
          )}
          {stepIndex === 2 && <AIReviewRelaxPanel task={task} />}
        </WizardStepWrapper>
      </Box>
    </IssbContainer>
  );
}
